import {useContext} from "react";
import {AuthContext} from "../contexts/AuthContext.tsx";
import {IAuthContext} from "../contexts/models/IAuthContext.ts";

export const useAuth = () => {
    return useContext<IAuthContext>(AuthContext);
}